import axios from './Axios';
import {
    FETCH_ALL_CALLS_REQUEST,
    FETCH_ALL_CALLS_SUCCESS,
    FETCH_ALL_CALLS_FAILURE,
    FETCH_CALL_TRANSCRIPT_REQUEST,
    FETCH_CALL_TRANSCRIPT_SUCCESS,
    FETCH_CALL_TRANSCRIPT_FAILURE,
    SELECT_CALL,
    CLEAR_CALL_ERROR
} from './Types';

/**
 * Fetch all calls with optional filtering
 */
export const FetchAllCallsAction = (limit = 50, offset = 0, status = null, fromNumber = null) => {
    return async (dispatch) => {
        dispatch({ type: FETCH_ALL_CALLS_REQUEST });

        try {
            const params = { limit, offset };
            if (status) params.status = status;
            if (fromNumber) params.from_number = fromNumber;

            const response = await axios.get('/api/calls/list/', { params });

            if (response.data && response.data.success) {
                dispatch({
                    type: FETCH_ALL_CALLS_SUCCESS,
                    payload: response.data.calls
                });
            } else {
                dispatch({
                    type: FETCH_ALL_CALLS_FAILURE,
                    payload: response.data.error || 'Failed to fetch calls'
                });
            }
        } catch (error) {
            dispatch({
                type: FETCH_ALL_CALLS_FAILURE,
                payload: error.response?.data?.error || error.message || 'Network error fetching calls'
            });
        }
    };
};

/**
 * Fetch call transcript with call details
 */
export const FetchCallTranscriptAction = (callId) => {
    return async (dispatch) => {
        dispatch({ type: FETCH_CALL_TRANSCRIPT_REQUEST });

        try {
            const response = await axios.get(`/api/calls/${callId}/transcript/`);

            if (response.data && response.data.success) {
                dispatch({
                    type: FETCH_CALL_TRANSCRIPT_SUCCESS,
                    payload: response.data.data
                });
            } else {
                dispatch({
                    type: FETCH_CALL_TRANSCRIPT_FAILURE,
                    payload: response.data.error || 'Failed to fetch call transcript'
                });
            }
        } catch (error) {
            dispatch({
                type: FETCH_CALL_TRANSCRIPT_FAILURE,
                payload: error.response?.data?.error || error.message || 'Network error fetching transcript'
            });
        }
    };
};

/**
 * Select a call (update UI state)
 */
export const SelectCallAction = (call) => {
    return {
        type: SELECT_CALL,
        payload: call
    };
};

/**
 * Clear call errors
 */
export const ClearCallErrorAction = () => {
    return {
        type: CLEAR_CALL_ERROR
    };
};
